export default function Segment() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <defs></defs>
      <g transform="translate(-162.504 -3775)">
        <g
          className="a"
          style={{ fill: "none", strokeWidth: "2px" }}
          transform="translate(162.504 3781.244)"
        >
          <circle
            className="c"
            style={{ stroke: "none" }}
            cx="12.878"
            cy="12.878"
            r="12.878"
          />
          <circle className="d" cx="12.878" cy="12.878" r="11.878" />
        </g>
        <path
          className="b"
          style={{
            fill: "none",
            strokeWidth: "2px",
            strokeLinecap: "round",
          }}
          d="M15948.5,2548.33v7.732h6.642"
          transform="translate(-15773.118 1239.415)"
        />
        <g
          className="a"
          style={{ fill: "none", strokeWidth: "2px" }}
          transform="translate(188.26 3775)"
        >
          <circle
            className="c"
            style={{ stroke: "none" }}
            cx="3.122"
            cy="3.122"
            r="3.122"
          />
          <circle
            className="d"
            style={{ fill: "none" }}
            cx="3.122"
            cy="3.122"
            r="2.122"
          />
        </g>
      </g>
    </svg>
  );
}
